import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/HomeView.vue'
import { routerModules } from '@/modules';

// 所有包含children的路由加hasChildren属性，所有子路由加rootRouterName属性
const formatChildrenRouters = (item, rootname) => {
  if (item.children && item.children.length > 0) {
    item.meta = {
      ...item.meta,
      hasChildren: true,
    };
    item.children.map((it) => {
      it.meta = {
        ...it.meta,
        rootRouterName: rootname,
      };
      return formatChildrenRouters(it, rootname);
    });
  }
  return item;
};

const loadRouterMessages = () => {
  let messages = [];
  const modulesKeys = Object.keys(routerModules);
  if (modulesKeys.length > 0) {
    for (let i = 0; i < modulesKeys.length; i += 1) {
      const matched = routerModules[modulesKeys[i]].keys();
      messages = [...messages, ...routerModules[modulesKeys[i]](matched[0]).default];
    }
  }
  const routrMessages = messages.map((item) => {
    const rootname = item.name;
    const obj = {
      ...item,
    };
    const newItem = formatChildrenRouters(obj, rootname);
    return newItem;
  });
  return routrMessages;
};

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Home,
      children: loadRouterMessages(),
      meta: {
        nomultipage: true,
      },
    },
    {
      path: '*',
      // redirect: '/', // 立即重定向
      name: '404',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    },
  ]
})